
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wallet/point",
      function () {
        return require("private-next-pages/wallet/point/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wallet/point"])
      });
    }
  